import { render, staticRenderFns } from "./RecentActivityTableDescriptionSubscriptionChanged.vue?vue&type=template&id=3eae15f4&"
import script from "./RecentActivityTableDescriptionSubscriptionChanged.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionSubscriptionChanged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports